import React from 'react'
import useForm from 'react-hook-form'

import { Grid, TextField } from '@material-ui/core'
import { RHFInput } from 'react-hook-form-input'

import helpers from 'helpers'
import ClientContext from 'contexts/ClientContext'
import InputPhone from 'components/InputPhone'
import InputCnpj from 'components/InputCnpj'
import InputCpf from 'components/InputCpf'
import schemas from 'views/Clients/schemas/index'

export default function Data() {
  const { data, setFormId, setData, nextStep } = React.useContext(ClientContext)
  const isCompany = helpers.people.isCompany(data.kind)
  const { register, handleSubmit, setValue, errors } = useForm({
    validationSchema: isCompany
      ? schemas.dataStepCompany
      : schemas.dataStepPerson,
    defaultValues: { ...data },
  })
  const formId = 'formStepData'

  React.useEffect(() => {
    setFormId(formId)
  }, [setFormId])

  const onSubmit = formData => {
    setData(data => ({ ...data, ...formData }))
    nextStep()
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} id={formId}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <RHFInput
            as={
              <TextField
                label="Email"
                margin="dense"
                error={!!errors.email}
                helperText={errors && errors.email && errors.email.message}
                fullWidth
              />
            }
            name="email"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <InputPhone
                label="Telefone"
                margin="dense"
                error={!!errors.phone}
                helperText={errors && errors.phone && errors.phone.message}
                fullWidth
              />
            }
            name="phone"
            register={register}
            setValue={setValue}
            mode="onChange"
          />
          <RHFInput
            as={
              <TextField
                label="Código de identificação"
                margin="dense"
                error={!!errors.code}
                helperText={errors && errors.code && errors.code.message}
                fullWidth
              />
            }
            name="code"
            register={register}
            setValue={setValue}
            mode="onChange"
          />
        </Grid>
        {isCompany && (
          <Grid item xs={12} md={4}>
            <RHFInput
              as={
                <TextField
                  label="Razão social"
                  margin="dense"
                  error={!!errors.companyName}
                  helperText={
                    errors && errors.companyName && errors.companyName.message
                  }
                  fullWidth
                />
              }
              name="companyName"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
            <RHFInput
              as={
                <TextField
                  label="Nome fantasia"
                  margin="dense"
                  error={!!errors.tradeName}
                  helperText={
                    errors && errors.tradeName && errors.tradeName.message
                  }
                  fullWidth
                />
              }
              name="tradeName"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
            <RHFInput
              as={
                <InputCnpj
                  label="CNPJ"
                  margin="dense"
                  error={!!errors.cnpj}
                  helperText={errors && errors.cnpj && errors.cnpj.message}
                  fullWidth
                />
              }
              name="cnpj"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
          </Grid>
        )}
        <Grid item xs={12} md={4}>
          <RHFInput
            as={
              <InputCpf
                label={`CPF ${isCompany ? '(opcional)' : ''}`}
                margin="dense"
                error={!!errors.cpf}
                helperText={errors && errors.cpf && errors.cpf.message}
                fullWidth
              />
            }
            name="cpf"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label={`Nome ${isCompany ? '(opcional)' : ''}`}
                margin="dense"
                error={!!errors.name}
                helperText={errors && errors.name && errors.name.message}
                fullWidth
              />
            }
            name="name"
            register={register}
            setValue={setValue}
            mode="onChange"
          />
        </Grid>
      </Grid>
    </form>
  )
}
